import React from 'react';
import t from 'prop-types';

var EntradaTipoAdorno = function EntradaTipoAdorno(_ref) {
  var num = _ref.num;
  return React.createElement('img', {
    className: 'adorno' + num,
    src: 'css/imagenes/menus/adorno' + num + '.png',
    alt: ''
  });
};

EntradaTipoAdorno.propTypes = process.env.NODE_ENV !== "production" ? {
  num: t.string
} : {};
export default EntradaTipoAdorno;